 export const service_menu1= 
    {  
      "card": [
       
        // {
        //   "id": 6,
        //   "menu_slug": "seo-services",
        //   "title": "Clutch Rating",
        //   "section_choice": "ClutchRating"
        // },
      
        {
          "id": 4,
          "menu_slug": "seo-services",
          "title": "Testimonials",
          "section_choice": "Testimonials"
        },
        {
          "id": 10,
          "menu_slug": "seo-services",
          "title": "Our Clients",
          "section_choice": "Brands"
        },
        {
          "id": 8,
          "menu_slug": "seo-services",
          "title": "Case Studies",
          "section_choice": "CaseStudies"
        },
        {
          "id": 7,
          "menu_slug": "seo-services",
          "title": "Services",
          "section_choice": "Service_Section"
        },
        {
          "id": 2,
          "menu_slug": "seo-services",
          "title": "Growth Strategy",
          "section_choice": "Growth_Section"
        },
       
        // {
        //   "id": 7,
        //   "menu_slug": "seo-services",
        //   "title": "About",
        //   "section_choice": "About"
        // },
       
      
        {
          "id": 3,
          "menu_slug": "seo-services",
          "title": "FAQ",
          "section_choice": "Faq"
        },
        // {
        //   "id": 2,
        //   "menu_slug": "seo-services",
        //   "title": "Quick Links",
        //   "section_choice": "QuickLinks"
        // },
        // {
        //   "id": 24,
        //   "menu_slug": "seo-services",
        //   "title": "Blogs",
        //   "section_choice": "Blogs"
        // },
        
      ]
    }
  